// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { findLocationModalStyles } from "@conklin/Overrides/Components/FindLocationModal";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xScreen } from "@conklin/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const fontStyles: TypographyPresentationProps = {
    color: "text.main",
    variant: "h5",
    size: 16,
    css: css`
        margin-bottom: 0;
    `,
};

findLocationModalStyles.distanceUnitOfMeasureImperialRadio = {
    css: css`
        margin-right: 10px;
    `,
} as any;

findLocationModalStyles.siteMessageResultsErrorText = {
    color: "danger",
    weight: fontConfig.weight.bold,
    css: css`
        margin-top: 8px;
    `,
};

findLocationModalStyles.searchResultLinksAndDistanceContainer = {
    gap: 10,
    css: css`
        width: 100%;
        padding: 5px;
        margin: 0;
    `,
};

findLocationModalStyles.searchResultDistanceGridItem = {
    width: [10, 10, 3, 4, 4],
    css: css`
        align-items: center;
    `,
};

findLocationModalStyles.searchResultHoursGridItem =
    findLocationModalStyles.searchResultGoogleMapsDirectionLinkGridItem = {
        width: [10, 10, 2, 3, 3],
        css: css`
            align-items: center;
        `,
    };

findLocationModalStyles.searchResultLeftGridItem = {
    width: [12, 12, 9, 9, 9],
};

findLocationModalStyles.searchResultLinksOffsetGridItem = {
    css: css`
        flex-basis: 12.5%;
        max-width: 12.5%;
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

findLocationModalStyles.mobileOffsetGridItem = {
    width: [2, 2, 0, 0, 0],
};

findLocationModalStyles.searchResultSelectButton = {
    variant: "primary",
};

findLocationModalStyles.searchResultSelectGridItem = {
    width: [0, 0, 0, 3, 3],
    css: css`
        justify-content: flex-end;
    `,
};

findLocationModalStyles.searchResultPhoneIcon = findLocationModalStyles.searchResultAddressInfoIcon = {
    color: "common.ui9",
    size: 20,
};

findLocationModalStyles.searchResultAddressInfoOffsetGridItem =
    findLocationModalStyles.searchResultPhoneOffsetGridItem = {
        width: 2,
        css: css`
            justify-content: center;
            align-items: center;
        `,
    };

findLocationModalStyles.searchResultDividerGridItem = {
    width: 12,
};

findLocationModalStyles.mobileSearchResultSelectGridItem = {
    width: [12, 12, 3, 0, 0],
    css: css`
        justify-content: flex-end;
    `,
};

findLocationModalStyles.selectedWarehouseDetailsGridItem = findLocationModalStyles.selectedWarehouseLinksGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        gap: 4px;
    `,
};

findLocationModalStyles.siteMessageGridItem = {
    width: 12,
    css: css`
        padding-top: 8px;
    `,
};

findLocationModalStyles.selectedWarehouseNameText = findLocationModalStyles.warehouseNameText = {
    ...fontStyles,
    ellipsis: true,
};

findLocationModalStyles.warehouseDisplayNumberText = {
    ...fontStyles,
    color: "common.ui9",
};

findLocationModalStyles.warehouseHoursLink =
    findLocationModalStyles.selectedWarehouseLink =
    findLocationModalStyles.selectedWarehouseGoogleMapsDirectionLink =
    findLocationModalStyles.warehouseGoogleMapsDirectionLink =
    findLocationModalStyles.searchResultPhoneLink =
    findLocationModalStyles.selectedWarehousePhoneLink =
        {
            typographyProps: {
                ...fontStyles,
            },
        };

findLocationModalStyles.selectedWarehouseAddressDisplay = findLocationModalStyles.warehouseAddressInfoCondensed = {
    wrapper: {
        css: css`
            line-height: 19px;
        `,
    },
};

findLocationModalStyles.selectedWarehouseDistanceText = findLocationModalStyles.warehouseDistanceDisplayText = {
    lineHeight: "19px",
};

findLocationModalStyles.pagination = {
    cssOverrides: {
        pagination: css`
            width: 100%;
        `,
        perPageSelect: css`
            display: none;
        `,
    },
};
